class TipoCadenciaEnum {
  constructor() {
    this.LIVRE_CONCORRENCIA = 1;
    this.COTA = 2;
  }

  /**
   * @returns {Array<{value: number, label: string}>}
   */
  getValues() {
    return [
      {
        value: this.LIVRE_CONCORRENCIA,
        label: 'Livre concorrência',
        desc: 'Motoristas são incluidos até que a cadência seja atingida',
      },
      {
        value: this.COTA,
        label: 'Cota',
        desc: 'Volume e cadência são definidos para cada transportadora.',
      },
    ];
  }

  /**
   * @param {number} value
   * @returns {string}
   */
  getTipoCadencia(value) {
    return this.getValues().find(item => item.value === value).label;
  }
}

export default new TipoCadenciaEnum();
